(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  if (!customElements.get('announcement-rotator')) {
    customElements.define(
      'announcement-rotator',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-rotator-track]');
          this.count = this.querySelectorAll('[data-rotator-item]').length;
          if (!this.track || this.count < 2) return;
          this.index = 0;
          this.querySelectorAll('[data-rotator-arrow]').forEach((arrow) => {
            arrow.addEventListener('click', () => {
              this.goTo(this.index + Number(arrow.dataset.direction));
              this.startTimer();
            });
          });
          this.startTimer();
        }
        goTo(index) {
          this.index = (index + this.count) % this.count;
          this.track.style.transform = `translateX(-${this.index * 100}%)`;
        }
        startTimer() {
          clearInterval(this.timer);
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this.timer = setInterval(() => this.goTo(this.index + 1), 4000);
        }
        disconnectedCallback() {
          clearInterval(this.timer);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('cart-drawer')) {
    customElements.define(
      'cart-drawer',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('.cart-drawer');
          this.confirm = this.querySelector('.mixed-confirm');
          this.onSubmit = (event) => {
            const form = event.target;
            if (!(form instanceof HTMLFormElement)) return;
            const action = form.getAttribute('action') || '';
            if (!action.includes('/cart/add')) return;
            event.preventDefault();
            if (this.conflicts(event.submitter)) {
              this.pending = { form, submitter: event.submitter };
              this.confirm.showModal();
              return;
            }
            this.add(form, event.submitter);
          };
          this.onOpenerClick = (event) => {
            const opener = event.target.closest('[data-cart-open]');
            if (!opener) return;
            event.preventDefault();
            this.open();
          };
          document.addEventListener('submit', this.onSubmit);
          document.addEventListener('click', this.onOpenerClick);
          this.addEventListener('click', (event) => {
            if (event.target.closest('[data-cart-close]')) this.dialog.close();
            const step = event.target.closest('[data-cart-change]');
            if (step) this.change(step.dataset.line, step.dataset.quantity);
            const arrow = event.target.closest('[data-scroll]');
            if (arrow) {
              const track = arrow.closest('[data-scroll-wrap]').querySelector('[data-scroll-track]');
              if (track) track.scrollBy({ left: Number(arrow.dataset.scroll) * track.clientWidth, behavior: 'smooth' });
            }
          });
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
          if (this.confirm) {
            this.confirm.addEventListener('click', (event) => {
              if (event.target.closest('[data-mixed-proceed]')) {
                const pending = this.pending;
                this.closeConfirm();
                if (pending) this.add(pending.form, pending.submitter);
                return;
              }
              if (event.target === this.confirm || event.target.closest('[data-mixed-cancel]')) {
                this.closeConfirm();
              }
            });
            this.confirm.addEventListener('close', () => {
              this.pending = null;
            });
          }
          this.loadRecommendations();
        }
        conflicts(submitter) {
          if (!this.confirm || !submitter) return false;
          const incoming = submitter.dataset.preorder;
          if (incoming === undefined) return false;
          const content = this.querySelector('[data-cart-content]');
          if (!content) return false;
          const opposite = incoming === 'true' ? content.dataset.hasInstock : content.dataset.hasPreorder;
          return opposite === 'true';
        }
        closeConfirm() {
          this.pending = null;
          this.confirm.close();
        }
        disconnectedCallback() {
          document.removeEventListener('submit', this.onSubmit);
          document.removeEventListener('click', this.onOpenerClick);
        }
        open() {
          document.querySelectorAll('dialog[open]').forEach((other) => {
            if (other !== this.dialog) other.close();
          });
          if (!this.dialog.open) this.dialog.showModal();
        }
        setBusy(busy) {
          const content = this.querySelector('[data-cart-content]');
          if (content) content.classList.toggle('is-busy', busy);
        }
        announce(message) {
          const status = this.querySelector('[data-cart-status]');
          if (status) status.textContent = message || '';
        }
        showError(message) {
          const error = this.querySelector('[data-cart-error]');
          if (!error) return;
          error.textContent = message;
          error.hidden = !message;
        }
        refresh(sections) {
          const html = sections && sections[this.dataset.sectionId];
          if (!html) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-cart-content]');
          const current = this.querySelector('[data-cart-content]');
          if (fresh && current) current.replaceWith(fresh);
          const count = fresh ? Number(fresh.dataset.cartCount) : 0;
          document.querySelectorAll('.header__cart-count').forEach((el) => {
            el.textContent = count > 0 ? count : '';
          });
          this.loadRecommendations();
        }
        async loadRecommendations() {
          const holder = this.querySelector('[data-cart-recommendations]');
          if (!holder) return;
          const productId = holder.dataset.firstProduct;
          if (!productId) {
            holder.innerHTML = '';
            return;
          }
          try {
            const params = new URLSearchParams({
              section_id: 'cart-recommendations',
              product_id: productId,
              limit: '6',
              intent: 'related',
            });
            const response = await fetch(`${holder.dataset.url}?${params}`);
            if (!response.ok) return;
            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const section = doc.querySelector('.shopify-section');
            holder.innerHTML = section ? section.innerHTML : '';
          } catch (error) {
            holder.innerHTML = '';
          }
        }
        async add(form, submitter) {
          let completed = false;
          const formData = new FormData(form);
          if (submitter && submitter.name && !formData.has(submitter.name)) {
            formData.append(submitter.name, submitter.value);
          }
          formData.append('sections', this.dataset.sectionId);
          if (submitter) submitter.disabled = true;
          document.dispatchEvent(new CustomEvent('ditch:cart-updated', { detail: { phase: 'pending' } }));
          try {
            const response = await fetch(`${this.dataset.addUrl}.js`, { method: 'POST', body: formData });
            const data = await response.json();
            if (!response.ok) {
              this.showError(data.description || data.message);
              this.open();
              return;
            }
            this.refresh(data.sections);
            completed = true;
            document.dispatchEvent(new CustomEvent('ditch:cart-updated', { detail: { phase: 'complete' } }));
            this.showError('');
            this.announce(this.dataset.updatedText);
            this.open();
          } catch (error) {
            this.showError(this.dataset.errorText);
            this.open();
          } finally {
            if (!completed) document.dispatchEvent(new CustomEvent('ditch:cart-updated', { detail: { phase: 'failed' } }));
            if (submitter) submitter.disabled = false;
          }
        }
        async change(line, quantity) {
          let completed = false;
          this.setBusy(true);
          document.dispatchEvent(new CustomEvent('ditch:cart-updated', { detail: { phase: 'pending' } }));
          try {
            const response = await fetch(`${this.dataset.changeUrl}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: Number(line), quantity: Number(quantity), sections: this.dataset.sectionId }),
            });
            const data = await response.json();
            if (!response.ok) {
              this.showError(data.description || data.message);
              return;
            }
            this.refresh(data.sections);
            completed = true;
            document.dispatchEvent(new CustomEvent('ditch:cart-updated', { detail: { phase: 'complete', cart: data } }));
            this.showError('');
          } finally {
            if (!completed) document.dispatchEvent(new CustomEvent('ditch:cart-updated', { detail: { phase: 'failed' } }));
            this.setBusy(false);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  if (!customElements.get('cart-page')) {
    customElements.define(
      'cart-page',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', (event) => {
            const step = event.target.closest('[data-cart-change]');
            if (step) this.change(step.dataset.line, step.dataset.quantity);
            const arrow = event.target.closest('[data-scroll]');
            if (arrow) {
              const track = arrow.closest('[data-scroll-wrap]').querySelector('[data-scroll-track]');
              if (track) track.scrollBy({ left: Number(arrow.dataset.scroll) * track.clientWidth, behavior: 'smooth' });
            }
          });
          this.loadRecommendations();
        }
        setBusy(busy) {
          const content = this.querySelector('[data-cart-content]');
          if (content) content.classList.toggle('is-busy', busy);
        }
        showError(message) {
          const error = this.querySelector('[data-cart-error]');
          if (!error) return;
          error.textContent = message;
          error.hidden = !message;
        }
        refresh(sections) {
          const html = sections && sections[this.dataset.sectionId];
          if (!html) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-cart-content]');
          const current = this.querySelector('[data-cart-content]');
          if (fresh && current) current.replaceWith(fresh);
          const count = fresh ? Number(fresh.dataset.cartCount) : 0;
          document.querySelectorAll('.header__cart-count').forEach((el) => {
            el.textContent = count > 0 ? count : '';
          });
          this.loadRecommendations();
        }
        async loadRecommendations() {
          const holder = this.querySelector('[data-cart-recommendations]');
          if (!holder) return;
          const productId = holder.dataset.firstProduct;
          if (!productId) {
            holder.innerHTML = '';
            return;
          }
          try {
            const params = new URLSearchParams({
              section_id: 'cart-recommendations',
              product_id: productId,
              limit: '6',
              intent: 'related',
            });
            const response = await fetch(`${holder.dataset.url}?${params}`);
            if (!response.ok) return;
            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const section = doc.querySelector('.shopify-section');
            holder.innerHTML = section ? section.innerHTML : '';
          } catch (error) {
            holder.innerHTML = '';
          }
        }
        async change(line, quantity) {
          let completed = false;
          this.setBusy(true);
          document.dispatchEvent(new CustomEvent('ditch:cart-updated', { detail: { phase: 'pending' } }));
          try {
            const response = await fetch(`${this.dataset.changeUrl}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: Number(line), quantity: Number(quantity), sections: this.dataset.sectionId }),
            });
            const data = await response.json();
            if (!response.ok) {
              this.showError(data.description || data.message);
              return;
            }
            this.refresh(data.sections);
            completed = true;
            document.dispatchEvent(new CustomEvent('ditch:cart-updated', { detail: { phase: 'complete', cart: data } }));
            this.showError('');
          } finally {
            if (!completed) document.dispatchEvent(new CustomEvent('ditch:cart-updated', { detail: { phase: 'failed' } }));
            this.setBusy(false);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  if (!customElements.get('collection-view')) {
    customElements.define(
      'collection-view',
      class extends HTMLElement {
        connectedCallback() {
          const toggle = this.querySelector('.collection__control--toggle');
          if (toggle) {
            toggle.addEventListener('click', () => {
              const active = this.classList.toggle('is-look');
              toggle.setAttribute('aria-pressed', String(active));
            });
          }
          const drawer = this.querySelector('.filter-drawer');
          if (!drawer) return;
          this.querySelectorAll('[data-filter-open]').forEach((button) => {
            button.addEventListener('click', () => drawer.showModal());
          });
          this.querySelectorAll('[data-filter-close]').forEach((button) => {
            button.addEventListener('click', () => drawer.close());
          });
          drawer.addEventListener('click', (event) => {
            if (event.target === drawer) drawer.close();
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('drop-grid-view')) {
    customElements.define(
      'drop-grid-view',
      class extends HTMLElement {
        connectedCallback() {
          const toggle = this.querySelector('.collection__control--toggle');
          if (!toggle) return;
          toggle.addEventListener('click', () => {
            const active = this.classList.toggle('is-look');
            toggle.setAttribute('aria-pressed', String(active));
          });
        }
      }
    );
  }

  if (!customElements.get('drop-notify')) {
    customElements.define(
      'drop-notify',
      class extends HTMLElement {
        connectedCallback() {
          const button = this.querySelector('button');
          if (button) button.addEventListener('click', () => this.open());
        }
        async open() {
          const id = (this.dataset.popupId || '').trim();
          const popups = window.postscript && window.postscript.popups;
          if (id && popups && popups.open) {
            try {
              await popups.open(/^\d+$/.test(id) ? Number(id) : id, {
                activePopupBehavior: 'ALWAYS_DISMISS',
                respectPopupStatus: false,
              });
              return;
            } catch (error) {
              // Fall through to the inline form
            }
          }
          const form = document.getElementById('drop-signup');
          if (!form) return;
          form.scrollIntoView({ behavior: 'smooth', block: 'center' });
          const input = form.querySelector('input');
          if (input) input.focus({ preventScroll: true });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('drop-hero-countdown')) {
    customElements.define(
      'drop-hero-countdown',
      class extends HTMLElement {
        connectedCallback() {
          this.values = {};
          this.querySelectorAll('[data-timer-unit]').forEach((el) => {
            this.values[el.dataset.timerUnit] = el;
          });
          this.target = this.parseTarget();
          // No usable date configured: stay hidden rather than counting down to nothing
          if (!this.target) {
            this.hidden = true;
            return;
          }
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        // The theme editor stores a wall-clock time in shop time (America/New_York).
        // Convert to a real instant so visitors in other time zones see the same deadline.
        parseTarget() {
          const raw = (this.dataset.date || '').trim();
          if (!raw) return null;
          const parts = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/);
          if (!parts) return null;
          const [, y, mo, d, h = '0', mi = '0'] = parts;
          const wall = Date.UTC(+y, +mo - 1, +d, +h, +mi, 0);
          const offsetAt = (ts) => {
            const p = Object.fromEntries(
              new Intl.DateTimeFormat('en-US', {
                timeZone: 'America/New_York',
                hour12: false,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
              })
                .formatToParts(new Date(ts))
                .map((part) => [part.type, part.value])
            );
            return Date.UTC(+p.year, +p.month - 1, +p.day, p.hour % 24, +p.minute, +p.second) - ts;
          };
          const guess = wall - offsetAt(wall);
          return wall - offsetAt(guess);
        }

        tick() {
          const remaining = this.target - Date.now();
          if (remaining <= 0) {
            clearInterval(this.timer);
            if (this.dataset.hideOnEnd === 'true' && !(window.Shopify && Shopify.designMode)) {
              this.hidden = true;
              return;
            }
          }
          const seconds = Math.max(0, Math.floor(remaining / 1000));
          const parts = {
            days: Math.floor(seconds / 86400),
            hrs: Math.floor(seconds / 3600) % 24,
            min: Math.floor(seconds / 60) % 60,
            sec: seconds % 60,
          };
          Object.entries(parts).forEach(([unit, value]) => {
            if (this.values[unit]) this.values[unit].textContent = String(value).padStart(2, '0');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-split"]) return;
  try {
    
  if (!customElements.get('read-more')) {
    customElements.define(
      'read-more',
      class extends HTMLElement {
        connectedCallback() {
          const toggle = this.querySelector('[data-toggle]');
          if (!toggle) return;
          toggle.addEventListener('click', () => {
            const open = this.classList.toggle('is-open');
            toggle.setAttribute('aria-expanded', String(open));
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event"]) return;
  try {
    
  if (!customElements.get('add-to-calendar')) {
    customElements.define(
      'add-to-calendar',
      class extends HTMLElement {
        connectedCallback() {
          const button = this.querySelector('button');
          if (!button) return;
          button.addEventListener('click', () => {
            const data = this.dataset;
            const clean = (value) => String(value || '').replace(/([,;\\])/g, '\\$1').replace(/\r?\n/g, ' ');
            const lines = [
              'BEGIN:VCALENDAR',
              'VERSION:2.0',
              'PRODID:-//DITCH//Journal//EN',
              'BEGIN:VEVENT',
              `UID:${data.url}`,
              `DTSTART;VALUE=DATE:${data.start}`,
              `DTEND;VALUE=DATE:${data.end}`,
              `SUMMARY:${clean(data.title)}`,
              `LOCATION:${clean(data.location)}`,
              `URL:${data.url}`,
              'END:VEVENT',
              'END:VCALENDAR',
            ];
            const blob = new Blob([lines.join('\r\n')], { type: 'text/calendar;charset=utf-8' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `${data.title || 'event'}.ics`;
            document.body.append(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(link.href);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('mega-nav')) {
    customElements.define(
      'mega-nav',
      class extends HTMLElement {
        connectedCallback() {
          this.header = this.closest('[data-mega-header]');
          this.menuToggle = this.querySelector('[data-menu-toggle]');
          this.drawer = this.querySelector('[data-menu-drawer]');
          this.items = Array.from(this.querySelectorAll('[data-desktop-item]'));
          this.views = Array.from(this.querySelectorAll('[data-drawer-submenu]'));
          this.closeTimer = null;

          this.onDocumentClick = (event) => {
            if (!event.target.closest('[data-desktop-item]')) this.closeDesktopMenus();
            if (this.drawer && this.drawer.classList.contains('menu-drawer--open')) {
              if (!this.drawer.contains(event.target) && !event.target.closest('[data-menu-toggle]')) {
                this.closeDrawer();
              }
            }
          };
          this.onKeydown = (event) => {
            if (event.key !== 'Escape') return;
            this.closeDesktopMenus();
            if (this.drawer && this.drawer.classList.contains('menu-drawer--open')) this.closeDrawer();
          };
          document.addEventListener('click', this.onDocumentClick);
          document.addEventListener('keydown', this.onKeydown);

          if (this.header.classList.contains('header--sticky') && this.header.classList.contains('header--overlay')) {
            this.onScroll = () => {
              this.header.classList.toggle('header--scrolled', window.scrollY > 4);
            };
            this.onScroll();
            window.addEventListener('scroll', this.onScroll, { passive: true });
          }

          if (this.menuToggle && this.drawer) {
            this.menuToggle.addEventListener('click', () => {
              this.drawer.classList.contains('menu-drawer--open') ? this.closeDrawer() : this.openDrawer();
            });
          }
          this.querySelectorAll('[data-menu-close]').forEach((button) => {
            button.addEventListener('click', () => this.closeDrawer());
          });

          this.querySelectorAll('[data-drawer-submenu-open]').forEach((button) => {
            button.addEventListener('click', () => this.openView(button.dataset.drawerSubmenuOpen));
          });
          this.querySelectorAll('[data-drawer-submenu-back]').forEach((button) => {
            button.addEventListener('click', () => {
              this.closeViews();
              const main = this.querySelector('[data-drawer-main]');
              if (main) main.scrollTop = 0;
            });
          });

          this.items.forEach((item) => {
            const toggle = item.querySelector('[data-desktop-toggle]');
            if (!toggle) return;
            item.addEventListener('mouseenter', () => this.openDesktopMenu(item));
            item.addEventListener('mouseleave', () => this.scheduleDesktopClose());
            item.addEventListener('focusin', () => this.openDesktopMenu(item));
            item.addEventListener('focusout', (event) => {
              if (!item.contains(event.relatedTarget)) this.scheduleDesktopClose();
            });
            toggle.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();
              const isOpen = item.classList.contains('header-nav__item--open');
              clearTimeout(this.closeTimer);
              this.closeDesktopMenus();
              if (!isOpen) this.openDesktopMenu(item);
            });
          });
        }
        disconnectedCallback() {
          document.removeEventListener('click', this.onDocumentClick);
          document.removeEventListener('keydown', this.onKeydown);
          if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
          document.body.classList.remove('menu-drawer-lock');
        }
        closeDesktopMenus() {
          clearTimeout(this.closeTimer);
          this.items.forEach((item) => {
            item.classList.remove('header-nav__item--open');
            const toggle = item.querySelector('[data-desktop-toggle]');
            if (toggle) toggle.setAttribute('aria-expanded', 'false');
          });
          this.header.classList.remove('header--mega-open');
        }
        scheduleDesktopClose() {
          clearTimeout(this.closeTimer);
          this.closeTimer = setTimeout(() => this.closeDesktopMenus(), 140);
        }
        openDesktopMenu(item) {
          this.closeDesktopMenus();
          item.classList.add('header-nav__item--open');
          this.header.classList.add('header--mega-open');
          const toggle = item.querySelector('[data-desktop-toggle]');
          if (toggle) toggle.setAttribute('aria-expanded', 'true');
        }
        closeViews() {
          if (!this.drawer) return;
          this.drawer.classList.remove('menu-drawer--submenu-open');
          this.views.forEach((view) => {
            view.classList.remove('menu-drawer__view--active');
            view.setAttribute('aria-hidden', 'true');
          });
        }
        openView(id) {
          if (!this.drawer || !id) return;
          this.views.forEach((view) => {
            const isActive = view.dataset.drawerSubmenu === id;
            view.classList.toggle('menu-drawer__view--active', isActive);
            view.setAttribute('aria-hidden', String(!isActive));
            if (isActive) view.scrollTop = 0;
          });
          this.drawer.classList.add('menu-drawer--submenu-open');
        }
        openDrawer() {
          this.closeViews();
          this.drawer.classList.add('menu-drawer--open');
          this.drawer.setAttribute('aria-hidden', 'false');
          this.menuToggle.setAttribute('aria-expanded', 'true');
          this.header.classList.add('header--drawer-open');
          document.body.classList.add('menu-drawer-lock');
        }
        closeDrawer() {
          this.drawer.classList.remove('menu-drawer--open');
          this.drawer.setAttribute('aria-hidden', 'true');
          this.menuToggle.setAttribute('aria-expanded', 'false');
          this.header.classList.remove('header--drawer-open');
          document.body.classList.remove('menu-drawer-lock');
          this.closeViews();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-carousel')) {
    customElements.define(
      'hero-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.hero__track');
          this.slides = Array.from(this.querySelectorAll('.hero__slide'));
          this.dots = Array.from(this.querySelectorAll('.hero__dot'));
          if (!this.track || this.slides.length < 2) return;
          this.index = 0;
          this.interval = Number(this.dataset.autoplay) * 1000 || 0;
          this.paused = new Set();
          this.behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          this.dots[0]?.classList.add('is-active');

          this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index)));
          this.track.addEventListener(
            'scroll',
            () => {
              requestAnimationFrame(() => {
                this.index = Math.round(this.track.scrollLeft / this.track.clientWidth);
                this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
              });
              this.schedule();
            },
            { passive: true }
          );

          if (!this.interval) return;
          this.addEventListener('focusin', () => this.pause('focus'));
          this.addEventListener('focusout', (event) => {
            if (!this.contains(event.relatedTarget)) this.resume('focus');
          });
          this.track.addEventListener('pointerdown', () => this.pause('pointer'), { passive: true });
          window.addEventListener('pointerup', () => this.resume('pointer'), { passive: true });
          this.onVisibility = () => (document.hidden ? this.pause('hidden') : this.resume('hidden'));
          document.addEventListener('visibilitychange', this.onVisibility);
          this.observer = new IntersectionObserver(([entry]) =>
            entry.isIntersecting ? this.resume('offscreen') : this.pause('offscreen')
          );
          this.observer.observe(this);
          this.addEventListener('shopify:block:select', (event) => {
            this.pause('editor');
            const index = this.slides.indexOf(event.target);
            if (index > -1) this.goTo(index);
          });
          this.addEventListener('shopify:block:deselect', () => this.resume('editor'));
          this.schedule();
        }

        disconnectedCallback() {
          clearTimeout(this.timer);
          this.observer?.disconnect();
          if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
        }

        goTo(index) {
          this.track.scrollTo({ left: index * this.track.clientWidth, behavior: this.behavior });
        }

        schedule() {
          clearTimeout(this.timer);
          if (!this.interval || this.paused.size) return;
          this.timer = setTimeout(() => this.goTo((this.index + 1) % this.slides.length), this.interval);
        }

        pause(reason) {
          this.paused.add(reason);
          clearTimeout(this.timer);
        }

        resume(reason) {
          this.paused.delete(reason);
          this.schedule();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["journal-records"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('journal-records')) {
    customElements.define(
      'journal-records',
      class extends HTMLElement {
        connectedCallback() {
          this.cd = this.querySelector('[data-cd]');
          if (!this.cd) return;
          if (CSS.supports('animation-timeline', 'view()')) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          const tilt = -12.91;
          let queued = false;
          const spin = () => {
            queued = false;
            const rect = this.getBoundingClientRect();
            const travel = window.innerHeight + rect.height;
            const progress = Math.min(Math.max((window.innerHeight - rect.top) / travel, 0), 1);
            this.cd.style.rotate = `${tilt - 180 + progress * 360}deg`;
          };
          this.onScroll = () => {
            if (queued) return;
            queued = true;
            requestAnimationFrame(spin);
          };
          spin();
          window.addEventListener('scroll', this.onScroll, { passive: true });
        }
        disconnectedCallback() {
          if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-row"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-row')) {
    customElements.define('product-row', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.product-row__track');
        this.listeners = new AbortController();
        const signal = this.listeners.signal;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.autoplay = this.classList.contains('product-row--marquee');
        this.direction = 1;
        this.pausedUntil = 0;
        this.hovering = false;
        this.focused = false;
        this.pointerInteraction = false;
        this.touchActive = false;
        this.scrolling = false;
        this.inView = false;
        const resetPosition = () => { this.pausedUntil = 0; this.autoPosition = null; };
        const endScroll = () => { this.scrolling = false; clearTimeout(this.scrollEndTimer); resetPosition(); };
        this.measureTrack = () => {
          const maxScroll = this.track.scrollWidth - this.track.clientWidth;
          this.maxScroll = Math.max(0, maxScroll);
          const duration = parseFloat(getComputedStyle(this).getPropertyValue('--marquee-duration')) || 40;
          this.speed = this.maxScroll / duration;
        };
        this.track.addEventListener('wheel', () => {
          this.scrolling = true;
          resetPosition();
          clearTimeout(this.scrollEndTimer);
          this.scrollEndTimer = setTimeout(endScroll, 120);
        }, { passive: true, signal });
        this.track.addEventListener('touchstart', () => {
          this.touchActive = true;
          this.focused = false;
          this.pointerInteraction = true;
          resetPosition();
        }, { passive: true, signal });
        const releaseTouch = (event) => {
          this.touchActive = event.touches.length > 0;
          resetPosition();
        };
        this.track.addEventListener('touchend', releaseTouch, { passive: true, signal });
        this.track.addEventListener('touchcancel', releaseTouch, { passive: true, signal });
        this.track.addEventListener('scroll', () => {
          if (!this.scrolling && !this.pointerDown && !this.touchActive) return;
          this.scrolling = true;
          this.autoPosition = null;
          clearTimeout(this.scrollEndTimer);
          if (!('onscrollend' in this.track)) this.scrollEndTimer = setTimeout(endScroll, 100);
        }, { passive: true, signal });
        this.track.addEventListener('scrollend', () => { if (this.scrolling) endScroll(); }, { signal });
        document.addEventListener('keydown', () => {
          this.pointerInteraction = false;
          if (this.contains(document.activeElement)) { this.focused = true; resetPosition(); }
        }, { signal });
        this.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') { this.hovering = true; this.autoPosition = null; } }, { signal });
        this.addEventListener('pointerleave', () => { this.hovering = false; resetPosition(); }, { signal });
        this.addEventListener('focusin', (event) => { this.focused = !this.pointerInteraction && event.target.matches(':focus-visible'); this.autoPosition = null; }, { signal });
        this.addEventListener('focusout', (event) => { this.focused = this.contains(event.relatedTarget) && event.relatedTarget.matches(':focus-visible'); resetPosition(); }, { signal });
        this.track.addEventListener('dragstart', (event) => event.preventDefault(), { signal });
        this.track.addEventListener('pointerdown', (event) => {
          resetPosition();
          this.focused = false;
          this.pointerInteraction = true;
          this.pointerDown = true;
          if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button, input, select, textarea')) return;
          this.drag = { x: event.clientX, scroll: this.track.scrollLeft, id: event.pointerId };
          this.dragged = false;
        }, { signal });
        this.track.addEventListener('pointermove', (event) => {
          if (!this.drag || this.drag.id !== event.pointerId) return;
          const delta = event.clientX - this.drag.x;
          if (!this.dragged && Math.abs(delta) < 5) return;
          this.dragged = true;
          this.track.setPointerCapture(event.pointerId);
          this.track.classList.add('is-dragging');
          this.track.scrollLeft = this.drag.scroll - delta;
          event.preventDefault();
        }, { signal });
        const release = (event) => {
          if (!this.pointerDown && !this.drag) return;
          if (this.drag && this.track.hasPointerCapture(this.drag.id)) this.track.releasePointerCapture(this.drag.id);
          this.drag = null;
          this.pointerDown = false;
          if (event.pointerType === 'mouse') {
            const bounds = this.getBoundingClientRect();
            this.hovering = event.clientX >= bounds.left && event.clientX <= bounds.right && event.clientY >= bounds.top && event.clientY <= bounds.bottom;
          }
          this.track.classList.remove('is-dragging');
          resetPosition();
          clearTimeout(this.dragReset);
          this.dragReset = setTimeout(() => { this.dragged = false; }, 0);
        };
        window.addEventListener('pointerup', release, { signal });
        window.addEventListener('pointercancel', release, { signal });
        this.track.addEventListener('click', (event) => {
          if (this.dragged) { event.preventDefault(); event.stopPropagation(); }
        }, { capture: true, signal });
        this.resizeObserver = new ResizeObserver(this.measureTrack);
        this.resizeObserver.observe(this.track);
        this.visibilityObserver = new IntersectionObserver(([entry]) => { this.inView = entry.isIntersecting; });
        this.visibilityObserver.observe(this);
        this.measureTrack();
        this.tick = (time) => {
          const elapsed = this.lastFrame === undefined ? 0 : Math.min(time - this.lastFrame, 50);
          this.lastFrame = time;
          if (this.autoplay && !this.motion.matches && this.inView && !document.hidden &&
              !this.hovering && !this.focused && !this.pointerDown && !this.touchActive && !this.scrolling && time >= this.pausedUntil && this.maxScroll > 1) {
            const next = (this.autoPosition ?? this.track.scrollLeft) + this.direction * this.speed * elapsed / 1000;
            this.autoPosition = Math.max(0, Math.min(this.maxScroll, next));
            this.track.scrollLeft = this.autoPosition;
            if (next >= this.maxScroll || next <= 0) {
              this.direction *= -1;
              this.pausedUntil = time + 1000;
            }
          }
          this.frame = requestAnimationFrame(this.tick);
        };
        if (this.autoplay) this.frame = requestAnimationFrame(this.tick);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.listeners?.abort();
        cancelAnimationFrame(this.frame);
        clearTimeout(this.dragReset);
        clearTimeout(this.scrollEndTimer);
        this.lastFrame = undefined;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('product-page')) {
    customElements.define(
      'product-page',
      class extends HTMLElement {
        connectedCallback() {
          this.behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          this.setupDialog();
          this.setupVariants();
          this.setupLinkedColors();
          this.setupSticky();
          this.setupDots();
          this.setupScrollers();
        }
        setupVariants() {
          this.addEventListener('click', (event) => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
            const swatch = event.target.closest('[data-variant]');
            if (!swatch) return;
            const section = this.closest('.shopify-section');
            if (!section || !this.dataset.sectionId) return;
            event.preventDefault();
            this.swap(swatch, section);
          });
        }
        setupLinkedColors() {
          const label = this.querySelector('[data-linked-color-label]');
          if (!label) return;
          const selectedColor = label.textContent;
          this.querySelectorAll('[data-linked-color]').forEach((link) => {
            const showColor = () => { label.textContent = link.dataset.linkedColor; };
            const restoreColor = () => { label.textContent = selectedColor; };
            link.addEventListener('mouseenter', showColor);
            link.addEventListener('focus', showColor);
            link.addEventListener('mouseleave', restoreColor);
            link.addEventListener('blur', restoreColor);
          });
        }
        async swap(swatch, section) {
          const id = swatch.dataset.variant;
          const url = this.dataset.url;
          section.setAttribute('aria-busy', 'true');
          try {
            const response = await fetch(`${url}?variant=${id}&section_id=${this.dataset.sectionId}`);
            if (!response.ok) throw new Error(response.status);
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const fresh = doc.getElementById(section.id) || doc.querySelector('.shopify-section');
            if (!fresh) throw new Error('missing section');
            section.replaceWith(fresh);
            history.replaceState({}, '', `${url}?variant=${id}`);
          } catch (error) {
            window.location = swatch.href;
          }
        }
        setupDialog() {
          const dialog = this.querySelector('.product__dialog');
          if (!dialog) return;
          this.querySelectorAll('[data-dialog-open]').forEach((button) => {
            button.addEventListener('click', () => dialog.showModal());
          });
          dialog.querySelectorAll('[data-dialog-close]').forEach((button) => {
            button.addEventListener('click', () => dialog.close());
          });
          dialog.addEventListener('click', (event) => {
            if (event.target === dialog) dialog.close();
          });
        }
        setupSticky() {
          const bar = this.querySelector('.product__sticky');
          const trigger = this.querySelector('.product__cta-row');
          if (!bar || !trigger) return;
          new IntersectionObserver(([entry]) => {
            bar.classList.toggle('is-visible', !entry.isIntersecting);
          }).observe(trigger);
        }
        setupDots() {
          const track = this.querySelector('.product__gallery-track');
          const dots = Array.from(this.querySelectorAll('.product__gallery-dot'));
          if (!track || dots.length < 2) return;
          dots[0].classList.add('is-active');
          dots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
              track.scrollTo({ left: index * track.clientWidth, behavior: this.behavior });
            });
          });
          track.addEventListener(
            'scroll',
            () => {
              requestAnimationFrame(() => {
                const index = Math.round(track.scrollLeft / track.clientWidth);
                dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
              });
            },
            { passive: true }
          );
        }
        setupScrollers() {
          this.querySelectorAll('[data-scroll]').forEach((button) => {
            button.addEventListener('click', () => {
              const track = button.closest('.product__look').querySelector('[data-scroll-track]');
              if (!track) return;
              track.scrollBy({ left: Number(button.dataset.scroll) * track.clientWidth, behavior: this.behavior });
            });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  if (!customElements.get('related-products')) {
    customElements.define(
      'related-products',
      class extends HTMLElement {
        connectedCallback() {
          const track = this.querySelector('[data-scroll-track]');
          if (!track) return;
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          this.querySelectorAll('[data-scroll]').forEach((button) => {
            button.addEventListener('click', () => {
              track.scrollBy({ left: Number(button.dataset.scroll) * track.clientWidth, behavior });
            });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  if (!customElements.get('search-page')) {
    customElements.define(
      'search-page',
      class extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('.search-page__input');
          this.results = this.querySelector('[data-search-results]');
          if (!this.input || !this.results) return;
          this.initial = this.results.innerHTML;
          this.input.addEventListener('input', () => {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.search(), 250);
          });
        }
        async search() {
          const query = this.input.value.trim();
          if (this.controller) this.controller.abort();
          if (!query) {
            this.results.innerHTML = this.initial;
            return;
          }
          this.controller = new AbortController();
          try {
            const params = new URLSearchParams({
              q: query,
              section_id: 'predictive-search',
              'resources[type]': 'query,product,page',
              'resources[limit]': '8',
              'resources[limit_scope]': 'each',
              'resources[options][unavailable_products]': 'last',
            });
            const response = await fetch(`${this.dataset.url}?${params}`, { signal: this.controller.signal });
            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const section = doc.querySelector('.shopify-section') || doc.body;
            this.results.innerHTML = section.innerHTML;
          } catch (error) {
            if (error.name !== 'AbortError') throw error;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timer-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('countdown-timer')) {
    customElements.define(
      'countdown-timer',
      class extends HTMLElement {
        connectedCallback() {
          this.values = {};
          this.querySelectorAll('[data-timer-unit]').forEach((el) => {
            this.values[el.dataset.timerUnit] = el;
          });
          this.target = this.targetTimestamp();
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }
        disconnectedCallback() {
          clearInterval(this.timer);
        }
        removeSelf() {
          (this.closest('.shopify-section') || this).remove();
        }
        newYorkParts(ts) {
          return Object.fromEntries(
            new Intl.DateTimeFormat('en-US', {
              timeZone: 'America/New_York',
              hour12: false,
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
            })
              .formatToParts(new Date(ts))
              .map((part) => [part.type, part.value])
          );
        }
        targetTimestamp() {
          const offset = (ts) => {
            const parts = this.newYorkParts(ts);
            return (
              Date.UTC(+parts.year, +parts.month - 1, +parts.day, parts.hour % 24, +parts.minute, +parts.second) - ts
            );
          };
          const build = (year) => {
            const guess = Date.UTC(year, +this.dataset.month - 1, +this.dataset.day, +this.dataset.hour, +this.dataset.minute);
            return guess - offset(guess - offset(guess));
          };
          const currentYear = +this.newYorkParts(Date.now()).year;
          const target = build(currentYear);
          if (target > Date.now() - 172800000) return target;
          return build(currentYear + 1);
        }
        tick() {
          const remaining = Math.max(0, this.target - Date.now());
          if (remaining === 0) {
            clearInterval(this.timer);
            if (this.dataset.hideOnEnd === 'true' && !(window.Shopify && Shopify.designMode)) {
              this.removeSelf();
              return;
            }
          }
          const seconds = Math.floor(remaining / 1000);
          const parts = {
            days: Math.floor(seconds / 86400),
            hrs: Math.floor(seconds / 3600) % 24,
            min: Math.floor(seconds / 60) % 60,
            sec: seconds % 60,
          };
          Object.entries(parts).forEach(([unit, value]) => {
            if (this.values[unit]) this.values[unit].textContent = String(value).padStart(2, '0');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
